module.exports = __webpack_public_path__ + "static/img/ico-doctor.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ico-doctor.png
// module id = 173
// module chunks = 0